export const riotbarHeight = "80px";
//# sourceMappingURL=dimensions.js.map